import axios from 'axios';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HOMES_AND_COMPANIES_URL } from '../../../constants/paths/api';
import { Input } from '../../base/forms/input';
import * as StyledHomeAndCompanies from './homeAndCompanies.styles';
import HomeAndCompaniesTable from './homeAndCompaniesTable';

interface Props {
	active: boolean;
}

const HomeAndCompanies: FC<Props> = ({ active }) => {
	const [value, setValue] = useState('');
	const [data, setData] = useState(null);
	const [filteredData, setFilteredData] = useState(null);
	const { t } = useTranslation('generalPostInfo');
	const onChange = async e => {
		try {
			setValue(e.target.value);
			const lowerCaseValue = e.target.value.toLowerCase();
			const filtered = data.map(region => {
				const postcodesList = region.postcodesList.filter(postcode => {
					if (
						postcode.postcode.toString().indexOf(lowerCaseValue) !== -1 ||
						postcode.place.toLowerCase().indexOf(lowerCaseValue) !== -1 ||
						region.postregion.toLowerCase().indexOf(lowerCaseValue) !== -1
					) {
						return true;
					}
					return false;
				});

				return {
					...region,
					postcodesList,
				};
			});
			setFilteredData(filtered);
		} catch (err) {
			console.log(err);
		}
	};

	useEffect(() => {
		if (!data && active) {
			axios
				.get(`${HOMES_AND_COMPANIES_URL}`)
				.then(homeAndCompaniesData => {
					setData(homeAndCompaniesData.data);
				})
				.catch(err => {
					console.log(err);
				});
		}
	}, [data, setData, active]);

	return (
		<StyledHomeAndCompanies.Wrapper>
			<StyledHomeAndCompanies.InputWrapper>
				<Input type="text" value={value} onChange={onChange} placeholder={`${t('address-search.search')}...`} />
			</StyledHomeAndCompanies.InputWrapper>
			<StyledHomeAndCompanies.TextWrapper>
				{t('address-search.info-text')}
			</StyledHomeAndCompanies.TextWrapper>
			<StyledHomeAndCompanies.TableWrapper>
				<HomeAndCompaniesTable data={filteredData || data} />
			</StyledHomeAndCompanies.TableWrapper>
		</StyledHomeAndCompanies.Wrapper>
	);
};

export default HomeAndCompanies;
